import { Injectable } from '@angular/core';
import { HttpServices } from './http-service.service';
import { ETenderSupplierEvaluation } from 'src/app/shared/models/e-tender.model';


@Injectable({
  providedIn: 'root'
})
export class EtenderEvaluationService {

  constructor(private http: HttpServices) { }
  public GetTenderSupplierEvaluation(tenderID: string) {
    return this.http.get('ETenderSupplierEvaluation/getETenderEvaluationByID?eTenderID=' + tenderID);
  }
  public setTenderWinner(winners: ETenderSupplierEvaluation[]) {
    return this.http.post('ETenderSupplierEvaluation/setTenderWinner', winners);
  }
  public evaluateETender(tenderEvaluations: ETenderSupplierEvaluation[]) {
    return this.http.post('ETenderSupplierEvaluation/evaluateETender', tenderEvaluations);
  }

  public GetTenderSupplierEvaluationList(pageIndex: number, pageSize: number, language: string,
                                         tenderName: string, supplierName: string, supplierResponse: boolean, involvedSupplier: boolean,
                                         isQualified: boolean, isHighPrice: boolean, isWinner: boolean,
                                         currentUser: string, supplierNumber: string, fileNumber: string) {
    return this.http.get('ETenderSupplierEvaluation/getETenderEvaluationReport?pageIndex=' + pageIndex
      + '&pageSize=' + pageSize + '&language=' + language + '&tenderName=' + tenderName
      + '&supplierName=' + supplierName + '&supplierResponse=' + supplierResponse
      + '&involvedSupplier=' + involvedSupplier + '&isQualified=' + isQualified
      + '&isHighPrice=' + isHighPrice + '&isWinner=' + isWinner + '&currentUser=' + currentUser
      + '&SupplierNumber=' + supplierNumber + '&fileNumber=' + fileNumber);
  }

}
